<template>
    <div>
        <div class="rubric-skill-content">
            <div class="title">{{ rubricRow.title }}</div>
            <div
                class="weight"
                v-if="showValues">
                <span class="label">{{ $t('rubrics.weight') }}</span
                >{{ rubricRow.weight }}
            </div>
        </div>
        <div class="rubric-navs-horizontal">
            <div class="nav-context">
                <b-dropdown
                    class="ellipsis-nav"
                    variant="primary"
                    toggle-class="text-decoration-none"
                    no-caret>
                    <template #button-content>
                        <i class="fas fa-fw fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                        class="btn-edit btn-edit-rubric-skill-row"
                        href="#"
                        @click="showUpdateRowModal">
                        {{ $t('common.edit') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        class="btn-remove-rubric-skill-row"
                        href="#"
                        @click="removeRow">
                        <i class="btn-remove"></i>{{ $t('common.delete') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <design-2021-rubric-edit-row-create-update-modal-component ref="rubric-edit-row-update">
        </design-2021-rubric-edit-row-create-update-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-rows-headings',
    props: {
        rubricRow: Object,
        showValues: Number,
        rubricRows: Array,
    },
    methods: {
        showCreateRowModal() {
            this.$refs['rubric-edit-row-update'].show(this.rubricRow, false, this.showValues, this.rubricRows);
        },

        showUpdateRowModal() {
            this.$refs['rubric-edit-row-update'].show(this.rubricRow, true, this.showValues, this.rubricRows);
        },

        removeRow() {
            this.alert
                .confirm(this.$t('rubrics.delete_row'), this.$t('rubrics.are_you_sure_you_want_to_delete_this_row'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.deleteRubricRow(this.rubricRow.id)).then(
                        (response) => {
                            this.rubricRow.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.rubric-skill-content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
}

.rubric-skill-content .title {
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'five');
}

.rubric-skill-content .weight {
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
}

.rubric-skill-content .weight .label {
    margin-right: map-get($grid-gutter-spacing, 'five');
}

.rubric-navs-horizontal {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    margin-top: -3px;
}

.ellipsis-nav ::v-deep {
    align-self: flex-end;

    .btn-remove-rubric-skill-row .dropdown-item {
        display: flex;
        align-items: center;
        flex-direction: row;

        i {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}
</style>
